/**
 * This RegExp gets all the caracters that cannot be used directly to an regexp expression.
 * Gets the characters +, \, [, ] and ?.
 * The first and last '/' starts and finish the regex expression.
 * The '[]' that encapsulates everything match any character that is inside of it.
 * '+' matches '+'
 * '\\' matches '\'
 * '[' matches '['
 * '\]' matches ']'
 * '?' matches '?'
*/ 
const invalidRegexCharacters = /[+\\[\]?]/;

/**
 * Regular expression to check if a value is a number.
 */
export const isNumber = /\d/;

export default invalidRegexCharacters;